import { UserAgent } from '#src/containers/UserAgent'

export default function getEstimatedDeviceWidth(ua: UserAgent) {
  /**
   * HACK: these are very rough estimates for devices sizes. We can drill into the UA
   * and come up with better estimates. e.g. iPhone5 vs iPhone7+
   */
  if (ua?.device.type === 'mobile') {
    // Our breakpoint "xs" is set to a typical/small smartphone size (360px). Less than that
    //   is an unusually small device.
    return '360px'
  } else if (ua?.device.type === 'tablet') {
    // Assumes a portrait layout, so we return the "sm" breakpoint size (768px) which roughly
    //   translates to a typical portrait tablet. Newer, larger tablets might be closer to
    //   desktop size.
    return '768px'
  } else {
    return '1024px'
  }
}
